import { useTranslation } from 'react-i18next';
import type {
  LoaderFunction,
  MetaDescriptor,
  MetaFunction
} from 'react-router';

import PageHeader from '~/components/PageHeader';
import useRegion from '~/hooks/useRegion';
import useViewEvent from '~/hooks/useViewEvent';
import { getRegion } from '~/utils/region';

import English from './English';
import German from './German';

const META_PER_REGION = {
  DE: [
    {
      title: 'Nutzungsbedingungen'
    }
  ],
  GB: [
    {
      title: 'Terms and Conditions'
    }
  ]
};

type LoaderData = {
  meta: MetaDescriptor[];
};

export const loader: LoaderFunction = ({ request }) => {
  const region = getRegion(new URL(request.url));

  return {
    meta:
      META_PER_REGION[region.code as keyof typeof META_PER_REGION] ??
      META_PER_REGION.GB
  };
};

export default function TermsAndConditions() {
  useViewEvent({ viewType: 'terms' });

  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: t('termsAndConditions') }
        ]}
        title={t('termsAndConditions')}
      />
      <article className="mx-auto my-8 flex max-w-3xl flex-col gap-4 px-4 md:my-20">
        <Content />
      </article>
    </>
  );
}

export const meta: MetaFunction = ({ data }) => {
  return (data as LoaderData).meta;
};

function Content() {
  const { code } = useRegion();

  switch (code) {
    case 'DE':
      return <German />;
    default:
      return <English />;
  }
}
